import { BaseResponse } from '@/app/shared/interface/common.interface';
import { Province, ProvinceV2 } from '@/app/shared/interface/province.interface';
import { AccountService } from '@/app/shared/services/account.service';
import { AuthService } from '@/app/shared/services/auth.service';
import { ProvinceService } from '@/app/shared/services/province.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, debounceTime } from 'rxjs';
import {BaseResponseModel} from "@/app/shared/interface/base-response.interface";
import { useSafeInterval } from '@/app/shared/ssr-util';

@Component({
  selector: 'app-welcome-new-customer',
  templateUrl: './welcome-new-customer.component.html',
  styleUrl: './welcome-new-customer.component.scss'
})
export class WelcomeNewCustomerComponent {

  @ViewChild('otpModal', { static: false }) otpModal: TemplateRef<any>;

  form: FormGroup;

  private executionSubscription: Subscription;
  private registerSubject = new Subject<any>();
  private registerSubscription: Subscription;

  public province: ProvinceV2;
  provinces: ProvinceV2[] = [];
  select2Provinces: any;
  debounceTimeMs = 500;
  phoneNo: string = '';
  otp: string = '';
  otpOptions: any = {
    length: 4,
    inputClass: 'input-otp',
    allowNumbersOnly: true,
    containerClass: 'd-flex justify-content-center',
  };
  step: number = 0;
  isValidatedOTP: boolean = true;
  second: number = 60;
  resendOTPInterval: any;

  public bodyCreateUser: {
    UserName: string;
    Password: string;
    Address: {
      Province: Province | undefined;
      Status: Number;
      ProvinceV2: ProvinceV2;
    };
    Referer: string;
    KnownWhere: string;
  };

  public bodyLogin: {
    username: string;
    password: string;
  };

  isBrowser: boolean = false;

  private safeInterval = useSafeInterval();

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toast: ToastrService,
    private provinceService: ProvinceService,
    private accountService: AccountService,
    private recaptchaV3Service: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.form = this.formBuilder.group({
      phone: new FormControl('', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^0[0-9]{9}$/)]),
      password: new FormControl('', [
        Validators.required, Validators.minLength(6),
      ]),
      repassword: new FormControl('', [
        Validators.required, Validators.minLength(6),
      ]),
      province: new FormControl('', [Validators.required]),
      phoneintroduce: new FormControl(''),
      referer: new FormControl('', [Validators.maxLength(10), Validators.minLength(10), Validators.pattern(/^0[0-9]{9}$/)]),
    });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;

      this.getProvincesInfo();

      this.registerSubscription = this.registerSubject.pipe(debounceTime(this.debounceTimeMs)).subscribe(() =>
        this.next()
      );

      // const script = document.createElement('script');
      // script.id = 'ladi-viewport-script';
      // script.innerHTML =
      //   `window.ladi_viewport = function (b) {
      //     var a = document;
      //     b = b ? b : "innerWidth";
      //     var c = window[b];
      //     var d = c < 768;
      //     if (
      //       typeof window.ladi_is_desktop == "undefined" ||
      //       window.ladi_is_desktop == undefined
      //     ) {
      //       window.ladi_is_desktop = !d;
      //     }
      //     var e = 1200;
      //     var f = 420;
      //     var g = "";
      //     if (!d) {
      //       g = "width=" + e + ",user-scalable=no,initial-scale=1.0";
      //     } else {
      //       var h = 1;
      //       var i = f;
      //       if (i != c) {
      //         h = c / i;
      //       }
      //       g =
      //         "width=" +
      //         i +
      //         ",user-scalable=no,initial-scale=" +
      //         h +
      //         ",minimum-scale=" +
      //         h +
      //         ",maximum-scale=" +
      //         h;
      //     }
      //     var j = a.getElementById("viewport");
      //     if (!j) {
      //       j = a.createElement("meta");
      //       j.id = "viewport";
      //       j.name = "viewport";
      //       a.head.appendChild(j);
      //     }
      //     j.setAttribute("content", g);
      //   };
      //   window.ladi_viewport();
      //   window.ladi_fbq_data = [];
      //   window.ladi_fbq = function () {
      //     window.ladi_fbq_data.push(arguments);
      //   };
      //   window.ladi_ttq_data = [];
      //   window.ladi_ttq = function () {
      //     window.ladi_ttq_data.push(arguments);
      //   };
      // `;
      // document.head.appendChild(script);
    }
  }

  getProvincesInfo() {
    this.provinceService.getProvinceV2InfoByDepth(0, 0).subscribe((res: ProvinceV2[]) => {
      if (res) {
        this.provinces = res;
        this.select2Provinces = this.provinces.map((province: ProvinceV2) => new Object({
          value: province.code,
          label: province.name
        }));
      }
    });
  }

  checkConfirmPasswordMatch(
    control: AbstractControl
  ) {
    const confirmPassword = control.parent?.get('repassword')?.value;

    if (confirmPassword && control.value !== confirmPassword) {
      control.parent?.get('repassword')?.setErrors({ notMatch: true });
      return true
    } else if (!control.parent?.get('repassword')?.getError('required')) {
      control.parent?.get('repassword')?.setErrors(null);
      control.setErrors(null);
      return false;
    }
    return false;
  }

  eventSelectProvince($event: any) {
    this.province = this.provinces.find(p => p.code == $event.value)!;
  }

  onProvinceBlur() {
    this.form.get('province')?.markAsTouched();
  }

  register() {
    this.registerSubject.next(null);
  }

  next() {
    this.form.markAllAsTouched();

    if (this.form.get('phone')?.hasError('required')) {
      this.toast.error('Vui lòng nhập số điện thoại', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.form.get('phone')?.hasError('pattern')) {
      this.toast.error('Số điện thoại không hợp lệ', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.form.get('password')?.hasError('required')) {
      this.toast.error('Vui lòng nhập mật khẩu', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.form.get('password')?.value.length < 6 || this.form.get('repassword')?.value.length < 6 ) {
      this.form.get('password')?.setErrors({ minlength: true });
      this.form.get('repassword')?.setErrors({ minlength: true });
      this.toast.error('Mật khẩu phải có ít nhất 6 ký tự', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }
    else if (
      this.form.get('password')?.value &&
      this.form.get('repassword')?.value &&
      this.form.get('password')?.value == this.form.get('repassword')?.value
    ) {
      this.form.get('password')?.setErrors(null);
      this.form.get('repassword')?.setErrors(null);
    }

    if (this.form.get('repassword')?.hasError('required')) {
      this.toast.error('Vui lòng nhập lại mật khẩu', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.checkConfirmPasswordMatch(this.form.get('password')!)) {
      this.toast.error('Mật khẩu không khớp', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.form.get('province')?.hasError('required')) {
      this.toast.error('Vui lòng chọn tỉnh/thành phố', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.form.get('phone')?.value == this.form.get('referer')?.value) {
      this.toast.error('Số điện thoại người giới thiệu không được trùng với số điện thoại đăng ký', '', {
        positionClass: 'toast-top-right',
        timeOut: 3000,
      });
      return;
    }

    if (this.form.invalid) {
      return;
    }

    this.phoneNo = this.form.get('phone')?.value;
    this.accountService.checkUserExist(this.phoneNo).subscribe({
      next: (res: boolean) => {
        if (res) {
          this.toast.error('Số điện thoại đã tồn tại', '', {
            positionClass: 'toast-top-right',
            timeOut: 3000,
          });
        } else {
          this.getOTP();
        }
      },
      error: (error: any) => {
        console.log(error);
        this.toast.error('Có lỗi xảy ra. Vui lòng thử lại sau', '', {
          positionClass: 'toast-top-right',
          timeOut: 3000,
        });
      },
    });
  }

  getOTP(newOTP: boolean = false) {
    let body: any = {
      phoneNo: this.phoneNo,
      // type: 0
    }
    if (newOTP) {
      body.newOTP = true;
    }
    this.executionSubscription = this.recaptchaV3Service.execute('register').subscribe({
      next: (token: string) => {
        body.recaptchaV3Token = token;
        this.accountService.retrieveOTP(JSON.stringify(body)).subscribe({
          next: (res: BaseResponse) => {
            if (res && res.statusCode === 200) {
              this.second = 60;
              this.countdown();
              this.step = 1;
              this.isValidatedOTP = true;
              this.toast.success(res.message, '', {
                positionClass: 'toast-top-right',
                timeOut: 3000,
              });
              this.openModal();
            }
            else {
              this.toast.error(res.message, '', {
                positionClass: 'toast-top-right',
                timeOut: 3000,
              });
            }
          },
          error: (error: any) => {
            console.log(error);
            this.toast.error('Có lỗi xảy ra. Vui lòng thử lại sau', '', {
              positionClass: 'toast-top-right',
              timeOut: 3000,
            });
          },
        });
      }
    });
  }

  countdown() {
    if (isPlatformBrowser(this.platformId)) {
      this.safeInterval.clear(this.resendOTPInterval);
      this.resendOTPInterval = this.safeInterval(() => {
        this.second--;
        $("#second").text(this.second);
        if (this.second === 0) {
          this.safeInterval.clear(this.resendOTPInterval);
        }
      }, 1000);
    }
  }

  async openModal() {
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.modalService
        .open(this.otpModal, {
          ariaLabelledBy: 'register-add-Modal',
          centered: true,
          windowClass: 'theme-modal modal-login modal-dialog-scrollable',
        })
        .result.then(
          (result) => {
            `Result ${result}`;
          }
        );
    }
  }

  onOtpChange(e: any) {
    this.otp = e;

    if (this.otp.length === this.otpOptions.length) {
      this.accountService.submitOTP(JSON.stringify({ phoneNo: this.phoneNo, otp: this.otp })).subscribe({
        next: (res: BaseResponseModel) => {
          if (res.isSuccess) {
            this.isValidatedOTP = true;
            this.submit();
          }
          else {
            this.isValidatedOTP = false;
            // this.toast.error('Mã OTP không đúng, xin vui lòng nhập lại', '', {
            //   positionClass: 'toast-top-right',
            //   timeOut: 3000,
            // });
          }
        },
        error: (error: any) => {
          console.log(error);
          this.toast.error('Có lỗi xảy ra. Vui lòng thử lại sau', '', {
            positionClass: 'toast-top-right',
            timeOut: 3000,
          });
        },
      });
    }
  }

  async submit() {
    if (this.form.get('password')?.value) {
      this.form.get('password')?.setErrors(null);
    }
    // Focus on the first invalid field
    const invalidControl = Object.keys(this.form.controls).find(
      controlName => this.form.get(controlName)?.invalid
    );
    if (invalidControl) {
      const invalidField = document.querySelector(`[formControlName="${invalidControl}"]`);
      if (invalidField) {
        (invalidField as HTMLElement).focus();
      }
      return;
    }

    if (this.form.valid) {
      this.bodyCreateUser = {
        Password: this.form.get('password')?.value,
        UserName: this.form.get('phone')?.value.toString(),
        Address: {
          Province: undefined,
          Status: 0,
          ProvinceV2: this.province,
        },
        Referer: this.form.get('referer')?.value || '',
        KnownWhere: 'Landing Page',
      };

      this.accountService.createUserV2(
        JSON.stringify(this.bodyCreateUser)
      ).subscribe({
        next: (res: any) => {
          if (res) {
            localStorage.removeItem('ref');
            this.bodyLogin = {
              username: this.form.get('phone')?.value,
              password: this.form.get('password')?.value,
            };
            this.authService.login(JSON.stringify(this.bodyLogin));
            this.authService.setRegister(res);
            this.modalService.dismissAll();
          }
        },
        error: (error) => {
          console.log(error);
          this.toast.error('Kiểm tra lại thông tin! Đã có tài khoản hoặc thông tin đăng ký sai', '', {
            positionClass: 'toast-top-right',
            timeOut: 5000,
            enableHtml: true,
          });
        },
      });
    }
  }

  ngOnDestroy() {
    this.executionSubscription?.unsubscribe();
    this.registerSubscription?.unsubscribe();

    if (isPlatformBrowser(this.platformId)) {
      const existingScript = document.getElementById('ladi-viewport-script');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    }
  }
}
